/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect } from 'react';
import Shimmer from 'sushiweb/Shimmer';
import { ParentNode } from './ParentNode';
import { ChildNode } from './ChildNode';
import { useGetChildNodes } from './apis';
import { green } from 'sushiweb/tokens/color';
import { AddEdit } from 'sushiweb/Icons';

const NodeHead = ({ nodeDetails, openFormHandler }) => {
  return (
    <>
      <div className='tw-flex tw-py-5 tw-px-5  tw-items-center tw-justify-start tw-gap-5 tw-relative'>
        <div className='tw-w-full tw-flex tw-justify-between'>
          <span className='tw-text-400 tw-font-extrabold '>
            {nodeDetails?.title}
          </span>
          <div
            className='tw-flex-col tw-justify-end tw-items-end tw-w-6 tw-h-6'
            css={`
              & div {
                z-index: 1;
              }
            `}
          >
            <span
              className='tw-w-6 tw-h-6 tw-flex tw-justify-center tw-items-center'
              onClick={() => {
                openFormHandler(true, null, null, 'root', 2, nodeDetails?.id);
              }}
            >
              <AddEdit size={12} color={green.z700} />
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export const NodeColumn = ({
  node,
  addNewRoot = false,
  handleChildNodeClick,
  rootId,
  updateChlidHandler,
  openFormHandler = { openFormHandler },
  refetchRootNodes,
  refetchParentEnable = false,
  setRefetchParentEnable = () => {},
}) => {
  const {
    data: childData,
    isLoading: childNodesLoading,
    refetch: fetchChildren,
  } = useGetChildNodes(
    rootId,
    {
      onSuccess: (childData) => {
        let updatedNode = [];
        for (let i = 0; i < childData.length; i++) {
          childData[i].onClick = handleChildNodeClick;
          childData[i].is_collapsed = true;
          if (childData[i]?.parent_id === node?.id) {
            updateChlidHandler(node?.id, childData);
          }
        }
      },
    },
    node,
  );

  useEffect(() => {
    if (node?.has_children) fetchChildren();
  }, [node]);

  return (
    <div className='tw-bg-indigo-100 tw-p-2 tw-flex-col tw-rounded-2xl tw-w-[30rem] tw-h-[85vh]  '>
      <NodeHead
        addNewRoot={addNewRoot}
        nodeDetails={node}
        refetchRootNodes={refetchRootNodes}
        openFormHandler={openFormHandler}
      />
      {childNodesLoading && (
        <div className='tw-flex tw-items-center tw-justify-center tw-h-full'>
          <Shimmer
            height='100%'
            width='100%'
            className='tw-bg-grey-100 tw-rounded-xl'
          />
        </div>
      )}
      {node?.children?.length && !childNodesLoading && (
        <div
          className='tw-flex tw-flex-col tw-gap-5 tw-overflow-y-scroll tw-rounded-xl tw-h-full'
          css={`
            ::-webkit-scrollbar {
              height: 5px;
              width: 5px;
            }
            ::-webkit-scrollbar-track {
              background: #e8eaf5;
            }
            ::-webkit-scrollbar-thumb {
              background: #cccacb;
              border-radius: 5px;
            }
            ::-webkit-scrollbar-thumb:hover {
              background: #8b8888;
            }
          `}
        >
          {node?.children.map((node) => {
            const CompName = node?.has_children ? ParentNode : ChildNode;

            return (
              <CompName
                key={node?.id}
                node={node}
                nodeId={node?.id}
                rootId={rootId}
                openFormHandler={openFormHandler}
                refetchRootNodes={refetchRootNodes}
                refetchParentEnable={refetchParentEnable}
                setRefetchParentEnable={setRefetchParentEnable}
              />
            );
          })}
        </div>
      )}
      <div
        className='tw-w-full tw-text-green-700 tw-flex tw-items-center tw-justify-center tw-font-bold tw-text-200 tw-my-4 tw-cursor-pointer'
        onClick={() => {
          openFormHandler(false, node?.id, rootId, 'option', 1);
        }}
      >
        + Add more
      </div>
    </div>
  );
};
